import type {
  InternalDropdownOption,
  InternalDropdownOptions,
} from '~/chords/DropdownSingleSelect/types';

/**
 * Update isVisible=true for all options.
 * Supports both flat and grouped (nested) option arrays.
 * @param options - The options to update (flat or grouped).
 * @returns The updated options with isVisible set to true.
 */
export function updateIsVisibleTrue(
  options: InternalDropdownOptions,
): InternalDropdownOptions {
  return options.map((group) => {
    const internalOptionsGroup = 'options' in group ? group.options : group;
    const updatedOptionsGroup = internalOptionsGroup.map(
      (option): InternalDropdownOption => ({
        ...option,
        isVisible: true,
      }),
    );

    if ('options' in group) {
      return {
        ...group,
        options: updatedOptionsGroup,
      };
    }

    return updatedOptionsGroup;
  });
}
